import styled from 'styled-components';
import { Box } from '@mui/material';

export const Container = styled.div`
  max-width: 550px;
  width: 100%;
`;

export const Drawer = styled.div<{ $open: boolean }>`
  position: fixed;
  border-radius: 10px;
  background-color: #ffffff;
  width: 550px;
  transition: all 1s ease-in-out;
  z-index: 11;
  padding: 10px 20px 20px 20px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.05);
  bottom: ${({ $open }) => ($open ? '-10px' : '-10px')};
  left: 50%;
  transform: translateX(-42%);
`;

export const Bold = styled.strong`
  font-weight: 600;
`;

export const FigurantList = styled(Box)`
  overflow-y: auto;
  height: 560px;
`;

export const Label = styled.div`
  width: 470px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Header = styled(Box)`
  display: flex;
  justify-content: space-between;
  height: 40px;
  align-items: center;
  margin-bottom: 10px;
`;

export const Column = styled(Box)`
  flex-basis: 0.5;
`;

export const Item = styled(Box)`
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  line-height: 40px;
  height: 40px;
`;
